import { style, animate, trigger, transition, state } from '@angular/animations';

export const UIConfigHideComponentAnimation = trigger('uiConfigHideComponent', [
	state('open', style({ opacity: 1, visibility: 'visible'})),
	state('closed', style({ opacity: 0, height: '0px', visibility: 'hidden', display: 'none' })),
	transition('isOpen <=> isClose', animate('50ms'))
]);
